/** @format */

/* eslint-disable */
import React from 'react'
import '../selectables.scss'
import Checkbox from '../../Checkbox/Checkbox'
import { PleaseWait } from '../../Loaders/PleaseWait'

function Commissions({
  disabled,
  isBusy,
  commissionsToBeSelected,
  onCheckCommissions,
  prefix,
}) {
  const handleCheckCommissions = (commission, checkValue) => {
    const com = [...commissionsToBeSelected].map(comm => {
      if (comm.id === commission.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })

    onCheckCommissions(com)
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <PleaseWait />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {commissionsToBeSelected.map(commission => (
            <li
              key={commission.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${commission.id}`}
                checked={commission.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleCheckCommissions(commission, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${commission.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  commission.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {commission.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}

export default Commissions
